'use client'

import { useEffect } from 'react'
import useSWR from 'swr'

import { signOut } from '@rewardops/auth/src/client'

import { useApi } from '../hooks/use-api'

const URL_FETCHER = (args: RequestInfo) => fetch(args).then((res) => res.json())

const SSOLogout = () => {
  const { tenant } = useApi()

  const { data: providerInfo, isLoading } = useSWR(
    '/api/auth/provider',
    URL_FETCHER,
  )

  useEffect(() => {
    if (!tenant) return

    // If the tenant is public, we don't need to check for a user
    if (tenant.flags.publicBrowsing) return

    // If the user doesn't have a session yet, we don't need to check if they are signed into the provider
    if (providerInfo?.noSession) return

    const isLoggedIn = providerInfo?.signedIn

    if (!isLoading && !isLoggedIn) {
      signOut({
        redirectUrl: window.location.href,
        logoutEndpoint: tenant?.logoutEndpoint,
      })
    }
  }, [tenant, providerInfo, isLoading])

  return null
}

export { SSOLogout }
